import { gql } from '@apollo/client';

export default gql`
  query getBookingsByProductCode(
    $startDate: String!
    $endDate: String!
    $passengerName: String!
    $passengerEmail: String!
    $productCodes: [String!]
    $customerBookingsOnly: Boolean = false
  ) {
    getBookingsByProductCode(
      startDate: $startDate
      endDate: $endDate
      passengerName: $passengerName
      passengerEmail: $passengerEmail
      productCodes: $productCodes
      customerBookingsOnly: $customerBookingsOnly
    ) {
      reference
      expiryTimestamp
      status
      allBookingItems @client {
        ...product
        status
      }
      outbound {
        origin {
          name
        }
        destination {
          name
        }
        timing {
          isoDate
        }
        products {
          ...product
        }
      }
      inbound {
        origin {
          name
        }
        destination {
          name
        }
        timing {
          isoDate
        }
        products {
          ...product
        }
      }
    }
  }
  fragment product on Product {
    name
    passenger {
      id
      disabilityType
      type
      email
    }
    priceWithCurrency
    isCancelled
    code
  }
`;
